import { makeStyles } from "@material-ui/core";

export const usePhotoTaggingStyles = makeStyles(() => ({
    title: {
        paddingBottom: 4
    },
    switch: {
        float: "right"
    }
}));
